const SHEET_ID = process.env.REACT_APP_GET_SHEET_ID;
const API_KEY = process.env.REACT_APP_GET_SHEET_API_KEY;
export const fetchSheetData = async (range = 'Sheet1') => {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${range}?key=${API_KEY}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.values;
  } catch (error) {
    console.error('Error fetching sheet data:', error);
    throw new Error('Unable to fetch data from Google Sheets');
  }
};